var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0227 13.0055V4.24711C17.0227 3.74167 16.6124 3.33175 16.1064 3.33175H11.3455C11.3455 2.04466 10.2998 1 9.01137 1C7.72296 1 6.67723 2.04466 6.67723 3.33175H1.9163C1.41035 3.33175 1 3.74167 1 4.24711V23.6284C1 24.1338 1.41035 24.5437 1.9163 24.5437H12.0294",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1395 13.0055H12.0308C11.5556 13.0055 11.1704 13.3903 11.1704 13.865V23.6842C11.1704 24.1589 11.5556 24.5437 12.0308 24.5437H22.1395C22.6147 24.5437 22.9999 24.1589 22.9999 23.6842V13.865C22.9999 13.3903 22.6147 13.0055 22.1395 13.0055Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6891 16.5597L17.1786 15.828C17.08 15.7809 16.9653 15.7809 16.8682 15.8309L15.4519 16.5464C15.2195 16.664 14.943 16.495 14.943 16.2335V13.004H19.1936V16.2438C19.1936 16.5024 18.9229 16.6713 18.6906 16.5582L18.6891 16.5597Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4854 3.33174V5.38873C13.4854 6.18361 12.8398 6.82862 12.0441 6.82862H5.83737C5.04167 6.82862 4.396 6.18361 4.396 5.38873V3.33174",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 10.8295L4.83433 11.6993L6.83165 9.70547",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 15.9044L4.83433 16.7742L6.83165 14.7789",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 20.8514L4.83433 21.7212L6.83165 19.726",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.965 9.84949H10.4189",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7964 20.6604H15.2489",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIconBlue);
export default __webpack_public_path__ + "static/media/InventoryIconBlue.fe2087a17f0f1760da460489b8a4197a.svg";
export { ForwardRef as ReactComponent };